import { ReleaseNotesQueryParams } from './useQueryReleaseNotes/types';

/**
 * Query key factory for release notes-related queries.
 */
export const queryKeysReleaseNotes = {
  base: () => 'releaseNotes' as const,
  get: (queryParams: ReleaseNotesQueryParams) =>
    [queryKeysReleaseNotes.base(), 'list', queryParams] as const,
} as const;
